export default __webpack_public_path__ + "static/media/yfi.88647f31.svg";